import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import Product from "../Common/Product";
import WirelessPlan from "./WirelessPlan";
import { updateKitQuantity, updateDeviceQuantity } from "../../Store/Catalog/Actions";
import { ProductLoader } from "../Loaders/Loaders";

class ItemsContainer extends Component {
    renderLoadingItems(count) {
        const items = [];

        for (let i = 0; i < count; i++) {
            const element =
                <div key={i} className="col-md-6 col-lg-4">
                    {ProductLoader(i)}
                </div>
            ;

            items.push(element);
        }

        return items;
    }

    // message below the progress bar for each step
    renderMessage() {
        const { filter, items, config: { DATA_PLANS_CATEGORY_ID } } = this.props;

        if (filter === "Plan" && items[0].category.id === DATA_PLANS_CATEGORY_ID) {
            var shortDescArray = items[0].shortDescription.split(" *");

            return (
                //  driven from the short description of the first item from the data plans
                <div className="highlighted-message">
                    {this.buildHighlightedMessage(shortDescArray)}
                </div>
            )
        } else {
            return null;
        }

    }

    buildHighlightedMessage(descArr) {
        var elements = _.map(descArr, (desc, index) => {
            if (index === 0) {
                return <div className="highlighted-message-body" key={index}>{desc}</div>
            } else {
                return <div className="highlighted-sub-container" key={index}><span className="highlighted-sub-message">*{desc}</span></div>
            }
            
        });
        return elements;
    }

    renderProducts() {
        const { items, showDetails, filter, addToCart, updateKitQuantity, updateDeviceQuantity, qtyReadOnly, wizard, wizardName, getCrossSellProducts, addToCartCb, showLoadingStatus, config: { DATA_PLANS_CATEGORY_ID, PANASONIC_DEVICE_IDS }, currentSelection, setCurrentId } = this.props;
        if (!items || items.length === 0) {
            return this.renderLoadingItems(6);
        } else {
            if (items[0].category.id === DATA_PLANS_CATEGORY_ID) {
                let itemArr = items;
                if (PANASONIC_DEVICE_IDS.includes(currentSelection)){
                    itemArr = itemArr.filter(x => x.name !== "T-Mobile Data Plans");
                }
                // wireless plans component
                return _.map(itemArr, product =>
                    <WirelessPlan
                        key={product.id}
                        filter={filter}
                        image={product.defaultPictureModel.fullSizeImageUrl}
                        title={product.name}
                        price={product.productPrice.price}
                        product={product}
                        wizardName={wizardName}
                        wizard={wizard}
                        addToCart={addToCart}
                        updateQuantity={filter === "Kit" ? updateKitQuantity : filter === "Device" ? updateDeviceQuantity : null}
                        qtyReadOnly={qtyReadOnly}
                        showDetails={showDetails}
                        productAttributes={product.productAttributes}
                    />
                );
            } else {
                // all other product components
                return _.map(items, product =>
                    <Product
                        key={product.id}
                        filter={product.category.name}
                        image={product.defaultPictureModel.fullSizeImageUrl}
                        title={product.name}
                        price={product.productPrice.price}
                        product={product}
                        wizardName={wizardName}
                        wizard={wizard}
                        addToCart={addToCart}
                        updateQuantity={filter === "Kit" ? updateKitQuantity : filter === "Device" ? updateDeviceQuantity : null}
                        qtyReadOnly={qtyReadOnly}
                        showDetails={showDetails}
                        productAttributes={product.productAttributes}
                        showLoadingStatus={showLoadingStatus}
                        getCrossSellProducts={getCrossSellProducts}
                        addToCartCb={addToCartCb}
                        displayStockAvailability={product.displayStockAvailability}
                        displayStockQuantity={product.displayStockQuantity}
                        stockQuantity={product.stockQuantity}
                        minStockQuantity={product.minStockQuantity}
                        setCurrentId={setCurrentId}
                    />
                );
            }
        }
    }

    render() {
        return <div>
            <div className="kit-wizard-message">
                <div className="row">
                    <div className="col-md-12">
                        {this.renderMessage()}
                    </div>
                </div>
            </div>
            <div className="masonry">
                <div className="masonry__container row masonry--active">
                    {this.renderProducts()}
                </div>
            </div>
        </div>;
    }
}

function mapStateToProps(state) {
    return {
        config: state.config
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateKitQuantity: updateKitQuantity,
        updateDeviceQuantity: updateDeviceQuantity
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemsContainer));
